import { urlParse } from '../../../common/utils';
import { getStorage, setStorage, isSupportStorage } from '../../../common/localStorage';

const pathname = location.pathname;
const urlParams = urlParse(window.location.href);
const htmlName = document.querySelector('html').getAttribute('name');
/**
 * 1、针对页面做判断是否需要展示
 * 2、疲劳度控制
 */

// 控制是否显示强制引流

/**
 * 
 * 1、先生成对应页面的config 包含页面ck等信息和是否显示
 * 2、判断当前是否是seo、引流等条件，限制展示
 * 3、根据疲劳度，控制是否需要再次展示
 * 
 * 返回config
 */
function init (defaultConfig) {
  // 生成对应页面的config
  const config = generatePageConfig(defaultConfig);
  // console.log(config.needShow);
  if (config.needShow) {
    // 判断当前是否需要限制展示
    config.needShow = judgeIsNeedShow();
  };

  return config;
}

// 生成对应页面的config
function generatePageConfig(_config) {
  let matchResult = '';
  if (window.__appName === 'wap2') {
    if (window.__pageUrl === '/home') {
      _config.page = 'home'
      _config.needShow = true
    } else if (window.__pageUrl === '/detail') {
      _config.page = 'detail'
      _config.needShow = true
    } else if (window.__pageUrl === '/search') {
      _config.page = 'list';
      _config.needShow = true;
      _config.pageSchema = `keyword=${urlParams.SearchText}`
    }
  }
  if (window.__pageUrl === '/searchweb/buy/productSearchResultAsyn.vhtml') {
    // 商品搜索列表
    if (htmlName === 'wapseo:list-keyword') {
      let keyword = '';
      // https://m.alibaba.com/trade/search?SearchText=mp3
      if (pathname === '/trade/search') {
        _config.page = 'list';
        keyword = urlParams.SearchText;
      // https://m.alibaba.com/products/mp3/2.html
      } else if (matchResult = pathname.match(/\/products\/([\s\S]+?)(?:\/\d+)?\.html/)) {
        keyword = matchResult[1];
      }
      _config.page = 'list';
      _config.needShow = true;
      _config.pageSchema = `keyword=${keyword}`
    // 类目搜索
    } else if (htmlName === 'wapseo:list-category') {
      // https://m.alibaba.com/Adapters_pid100009649
      if (matchResult = pathname.match(/\/(.+)_pid(.+)/)) {
        _config.page = 'list';
        _config.needShow = true;
        _config.pageSchema = `categoryId=${matchResult[2]}&categoryName=${matchResult[1]}`
      // https://m.alibaba.com/catalogs/--100009649/2
      } else if (matchResult = pathname.match(/\/catalogs\/-*(\d+)/)) {
        _config.page = 'list';
        _config.needShow = true;
        _config.pageSchema = `categoryId=${matchResult[1]}`
      }
    // SEO列表
    } else if (htmlName === 'wapseo:seo-list-showroom') {
      // https://m.alibaba.com/showroom/grease/--1001/2.html
      if (matchResult = pathname.match(/\/showroom\/(.+)\/-+(\d+)/)) {
        _config.page = 'list';
        _config.needShow = true;
        _config.pageSchema = `cateName=${matchResult[1]}&cateId=${matchResult[2]}`
      // https://m.alibaba.com/showroom/mp3.html
      } else if (matchResult = pathname.match(/\/showroom\/(.+)\.html/)) {
        _config.page = 'list';
        _config.needShow = true;
        _config.pageSchema = `keyword=${matchResult[1]}`
      }
    }
  // 多语言搜索列表
  } else if (window.__pageUrl === '/multilanguage/mlProductListAsyn.vhtml') {
    if (htmlName.indexOf('ml-list-') > -1) {
      // https://m.thai.alibaba.com/products/MP3/2.html
      if (matchResult = pathname.match(/\/products\/([\s\S]+?)(?:\/\d+)?\.html/)) {
        _config.page = 'list';
        _config.needShow = true;
        _config.pageSchema = `keyword=${matchResult[1]}`
      // https://m.thai.alibaba.com/Auction_pid2802   
      } else if (matchResult = pathname.match(/\/(.+)_pid(.+)/)) {
        _config.page = 'list';
        _config.needShow = true;
        _config.pageSchema = `categoryId=${matchResult[2]}&categoryName=${matchResult[1]}`
      }
    } else if (htmlName.indexOf('ml-product-list-') > -1) {
      // https://m.thai.alibaba.com/Popular/CN_MP3-Trade.html
      if ( matchResult = (pathname.match(/Popular\/(?:\w+)_(.+)-Trade(?:\/\d+)?\.html/)) ) {
        _config.page = 'list';
        _config.needShow = true;
        _config.pageSchema = `keyword=${matchResult[1]}`
      }
    }
  // 产品detail
  } else if (window.__pageUrl == '/detail/introductionDetail.vhtml' || window.__pageUrl == '/multilanguage/mlProductDetail.vhtml') {
    _config.page = 'detail'
    _config.needShow = true;
  }
  // 当为付费引流的承接页时，当前会话不显示强制浮层  只在承接页不显示，detail还是显示， bug营销
  if (urlParams.src === 'cpm_fb') {
    // sessionStorage.notShowForceDialog = true
    _config.needShow = false;
  }
  return _config
}

// 控制是否需要展示
function judgeIsNeedShow() {
  let pageNeedShow = true;
  // SEO渠道不弹框
  if (window.isSEOChannel === 'true' || htmlName === 'wapseo:seo-list-showroom') {
    pageNeedShow = false
  };
  // 处理当前会话不展示的逻辑
  if (sessionStorage.notShowForceDialog) {
    pageNeedShow = false
  }
  // 如果需要展示，则判断是否满足疲劳度需求
  // console.log(pageNeedShow)
  if (pageNeedShow) {
    pageNeedShow = judgeFatigueShow();
  }
  return pageNeedShow;
}

// 控制疲劳度
function judgeFatigueShow () {
  // 如果不支持localstorage则 不显示强制引流
  if (!isSupportStorage()) return false

  let lastTime = getStorage('openAppTime');
  let nowTime = Date.now();
  // 控制疲劳度
  const gap = handlerBeatenGap();
  // console.log(lastTime, (nowTime - lastTime), gap)
  if (!lastTime || (lastTime && (nowTime - lastTime) > gap)) {
    setStorage('openAppTime', nowTime);
    return true;
  }
  return false;
}

// 控制疲劳度时间
function handlerBeatenGap () {
  let gap = 24 * 60 * 60 * 1000;
  // 只有当为首页的时候才为7天的疲劳度，其他的都是1天
  if (window.__appName === 'wap2' && window.__pageUrl === '/home') {
    gap = gap * 7;
  }
  return gap
}

export default init;



// WEBPACK FOOTER //
// ./src/modules/download-app/force/controller.js